
export class CsvUpload {
  public UploadType : number;
  public Items : any;
}

export class ItemCsv {
  public ItemName: string;
  public ItemDescription: string;
  public InOnlineStore: string;
  public InCheckout: string;
  public InAllLocations: string;
  public Location: number;
  public TaxCode: string;
  public ItemUnit: string;
  public SKU: string;
  public Price: number;
  public ImageUrl: string;
  public Include: number;
}

export class CsvImportUpload {
  public ApplicationUserId : any;
  public Items: any;
  public Overwrite: boolean;
}
